import axiosInstance from 'api/axiosInstance';

// Returns whether ANY of the given companies has at least one active parking lot,
// answered by a single backend existence query — instead of one getParkingLocations
// request per company, which storms the API for accounts with hundreds of companies.
// Served by the node /api3.2 surface (not the legacy C# api2.0 service).
export const hasAnyParkingLocation = async (
	companyIds: string[],
): Promise<boolean> => {
	if (!companyIds.length) return false;
	const response = await axiosInstance.post(
		'/api3.2/canpark/parking-locations/exists',
		{ companyIds },
	);
	return response.data?.data?.exists === true;
};
